import { render, staticRenderFns } from "./PasswordRestore.vue?vue&type=template&id=b6d764fe&scoped=true"
import script from "./PasswordRestore.vue?vue&type=script&lang=js"
export * from "./PasswordRestore.vue?vue&type=script&lang=js"
import style0 from "./PasswordRestore.vue?vue&type=style&index=0&id=b6d764fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d764fe",
  null
  
)

export default component.exports